import { useSuspenseQuery } from "@tanstack/react-query";
import { DependencyList } from "react";

type Factory<T> = () => T;

/** Suspends the calling component until the given promise resolves, yielding the result */
export function usePromise<T>(f: Factory<Promise<T>>, deps: DependencyList = []): T {
    return useSuspenseQuery({
        queryKey: ["_usePromise", ...deps],
        queryFn: f,
    }).data;
}
